import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { forkJoin } from 'rxjs';
import { BrukerService } from 'src/app/services/bruker/bruker.service';
import { FeatureTogglesService } from 'src/app/services/feature-toggles/feature-toggles.service';
import { FeatureToggle } from 'src/app/services/feature-toggles/toggles.types';
import { Browser } from '@capacitor/browser';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent {
  feedbackDisabled: boolean = false;
  customerGuid: string;
  fornavn: string;
  isIos: boolean;
  constructor(public toggleService: FeatureTogglesService, public brukerService: BrukerService, private platform: Platform) {}


  ngOnInit() {
    this.isIos = this.platform.is('ios') && !this.platform.is('mobileweb');
    forkJoin({
      toggle: this.toggleService.getActiveFeatureToggles(),
      customer: this.brukerService.getKunde()
    }).subscribe({
      next: ({toggle, customer}) => {        
        this.feedbackDisabled = this.getIsFeedbackEnabled(toggle) ?? true;
        this.customerGuid = customer.kunde.customerGuid;
        this.fornavn = customer.kunde.fornavn;
      },
      error: (_) => {
        this.feedbackDisabled = true;
      },
    })

  }
  getIsFeedbackEnabled(toggles: FeatureToggle[]): boolean {
    const myToggle = toggles.find((x) => x.navn === 'tilbakemelding_acktiv');
    return myToggle ? myToggle.toggleActive === 'NOW' : false;
  }

  openFeedback() {
    const url = `https://ishavskraft.typeform.com/to/sgkM6or3#kunde_guid=${this.customerGuid}&fornavn=${this.fornavn}`
    if (this.platform.is('capacitor')) {
      Browser.open({ url: url});
    } else {
      window.open(url);
    }
  }
}
